import { createContext, useState, ComponentType, SetStateAction, Dispatch } from 'react';
import { HotSpotItem } from 'Guide/Schematics/Diagram/Providers/dataContext';

const noop = () => {};

const orderContextDefaults = {
   item: {} as HotSpotItem,
   setItem: noop as Dispatch<SetStateAction<HotSpotItem>>,
};

const OrderContext = createContext(orderContextDefaults);

function withOrderContext<P>(Component: ComponentType<P>) {
   return function OrderContextProvider(props: P) {
      const [item, setItem] = useState({} as HotSpotItem);

      const orderContext = {
         item,
         setItem,
      };

      return (
         <OrderContext.Provider value={orderContext}>
            {/*
            // @ts-expect-error TS(2322) FIXME: Type 'P' is not assignable to type 'IntrinsicAttributes & P'. */}
            <Component {...props} />
         </OrderContext.Provider>
      );
   };
}

export { withOrderContext, OrderContext };
